import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/siteConfig";

export default function CTASection() {
  return (
    <section className="w-full py-20 md:py-28 bg-white">
      <div className="w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
          准备好开始探索 {siteConfig.name} 了吗？
        </h2>
        <p className="text-foreground-500 max-w-xl mx-auto mb-10 leading-relaxed">
          加入超过 100 万用户的 {siteConfig.name}{" "}
          社区，体验全新的工作方式。免费注册，无需信用卡。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tutorial"
            className="px-8 py-3.5 text-sm font-medium rounded-full bg-foreground-950 text-white hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费开始使用
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 text-sm font-medium rounded-full border border-foreground-200 text-foreground-700 hover:border-foreground-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}